// extracted by mini-css-extract-plugin
module.exports = {"container":"BoostButton__container__3xnfb","btn":"BoostButton__btn__1ivkn","timer":"BoostButton__timer__p7tn3"};